import { Dispatch, PropsWithChildren, SetStateAction, useEffect } from 'react'
import ProductItem from './ProductItem'
import {
  Control,
  FieldArrayWithId,
  FieldErrors,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FormValues } from 'utils/type'
import { Me, Usage } from 'service/user'
import { LinkDetailType, PromptGroup } from 'service/list'
import { CreateVideoType } from '@/constant/videoTypes'

interface ProductListProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  fields: FieldArrayWithId<FormValues, 'products', 'id'>[]
  errors: FieldErrors<FormValues>
  setErrorText: Dispatch<React.SetStateAction<React.ReactNode>>
  userInfo: Me
  usage: Usage | undefined
  error: {
    products: {
      link: boolean
      product: boolean
    }[]
    mainTitle: boolean
    thumbnail: boolean
  }
  selectedLinks: LinkDetailType[]
  setError: any
  isAiName: boolean
  promptGroupList: PromptGroup[]
  translatePlanName: (planName: string) => string
  setPromptStatus: Dispatch<SetStateAction<boolean[]>>
  setToneTooltip: Dispatch<SetStateAction<boolean[]>>
  promptStatus: boolean[]
  toneTooltip: boolean[]
  createVideoType: CreateVideoType
}
const ProductList = ({
  watch,
  setValue,
  control,
  fields,
  errors,
  error,
  setErrorText,
  userInfo,
  usage,
  selectedLinks,
  setError,
  isAiName,
  promptGroupList,
  translatePlanName,
  setPromptStatus,
  setToneTooltip,
  promptStatus,
  toneTooltip,
  createVideoType,
}: PropsWithChildren<ProductListProps>) => {
  useEffect(() => {
    // new Array(3).fill(1).forEach((el, index) => {
    //   setValue(`products.${index}`, {
    //     link: '',
    //     productName: '',
    //     files: [],
    //     selectedFiles: [],
    //     selectedDetails: [],
    //     selectedThumbnails: [],
    //     selectedVideos: [],
    //   })
    // })
  }, [selectedLinks])
  return (
    <>
      <div className="flex flex-col items-center w-[375px] md:w-[736px] gap-32">
        {selectedLinks.map((item: any, index: number) => (
          <ProductItem
            key={index}
            index={index}
            control={control}
            errors={errors}
            error={error}
            userInfo={userInfo}
            watch={watch}
            usage={usage}
            setValue={setValue}
            setErrorText={setErrorText}
            selectedLink={selectedLinks[index]}
            setError={setError}
            isAiName={isAiName}
            promptGroupList={promptGroupList}
            setPromptStatus={setPromptStatus}
            setToneTooltip={setToneTooltip}
            promptStatus={promptStatus}
            toneTooltip={toneTooltip}
            translatePlanName={translatePlanName}
            createVideoType={createVideoType}
          />
        ))}
      </div>
    </>
  )
}
export default ProductList
